import { render, staticRenderFns } from "./diagram_performance_warning.vue?vue&type=template&id=7ad2c71e"
import script from "./diagram_performance_warning.vue?vue&type=script&lang=js"
export * from "./diagram_performance_warning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports